var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1143 18.4415L17.1391 14.4671C16.9597 14.2877 16.7165 14.188 16.4613 14.188H15.8114C16.9119 12.7808 17.5658 11.0108 17.5658 9.08542C17.5658 4.50504 13.8538 0.793701 9.27262 0.793701C4.69147 0.793701 0.979492 4.50504 0.979492 9.08542C0.979492 13.6658 4.69147 17.3771 9.27262 17.3771C11.1984 17.3771 12.9687 16.7234 14.3761 15.6231V16.2729C14.3761 16.528 14.4758 16.7712 14.6552 16.9506L18.6303 20.925C19.0051 21.2998 19.6111 21.2998 19.9819 20.925L21.1103 19.7969C21.4851 19.4222 21.4851 18.8162 21.1143 18.4415ZM9.27262 14.188C6.45376 14.188 4.16916 11.9078 4.16916 9.08542C4.16916 6.26703 6.44977 3.98282 9.27262 3.98282C12.0915 3.98282 14.3761 6.26304 14.3761 9.08542C14.3761 11.9038 12.0955 14.188 9.27262 14.188Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.76b562b3250143fbeb4e480d76aa31a2.svg";
export { ForwardRef as ReactComponent };